import React from 'react';
import PropTypes from 'prop-types';

import StandardInputFile from '@/common/components/input/StandardInputFile';

interface Props {
  onImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CourseImageStep: React.FC<Props> = ({ onImageChange }) => (
  <div className='flex flex-col gap-[16px] w-full'>
    <div className='flex flex-col gap-2 bg-surface_gray_200 rounded-lg p-4 border border-border_gray_300'>
      <p className='text-base'>Add a cover image for your course.</p>
      <p className='text-sm text-text_gray_900'>
        Choose an image that represents your course content. Recommended size is 1280x720 pixels.
      </p>
    </div>

    <StandardInputFile
      id='courseImage'
      label='Course Image'
      accept='image/*'
      onChange={onImageChange}
    />
  </div>
);

CourseImageStep.propTypes = {
  onImageChange: PropTypes.func.isRequired,
};

export default CourseImageStep;
